// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n#exam[data-v-7ee6ad5c] {\r\n  border-radius: 6px;\r\n  cursor: pointer;\n}\n.text[data-v-7ee6ad5c] {\r\n  font-size: 0.6rem;\n}\r\n", ""]);
// Exports
module.exports = exports;
